import axios from './../../../config/apiConfig';
import { React, useState, useEffect} from 'react';
import NavigationUser from '../../common/navigationUser/NavigationUser';
import { CustomButton, CustomPaginate, LoadingTable } from '../../utils/Utils';
import style from './conferences.module.scss';
import { useHistory } from 'react-router';
import moment from 'moment';

const Conferences = () => {
  const { container, confItem, confDate, tabNav } = style;
  let history = useHistory();
  const [page, setPage] = useState(1);
  const [givenPage, setGivenPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [arePastConf, setArePastConf] = useState(false);

  const [conferences, setConferences] = useState([]);
  const [reqState, setReqState] = useState(false);

  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (conferences.length === 0) {
      if (reqState) {
        setNoData(true);
        setLoading(false);
      } else {
        setNoData(false);
        setLoading(true);
      }
    } else {
      setNoData(false);
      setLoading(false);
    }
  }, [reqState]);
  
  useEffect(() => {
    if (page !== givenPage) {
      getConferences();
    }
  }, [page]);

  useEffect(() => {
    if (arePastConf) {
      setPage(1);
      setGivenPage(1);
      getConferences(true);
    } else {
      setPage(1);
      setGivenPage(1);
      getConferences(false);
    }
  }, [arePastConf]);

  const getConferences = async (pastConf) => {
    try {
      setConferences([]);
      setReqState(false);
      const date = moment();
      const { data } = await axios.get(`/conferences/?page=${page}&size=12${pastConf ? `&dateTo=${date}` : `&dateSince=${date}`}`);
      setConferences(data.data[0].conferences);
      setTotalPages(data.data[0].totalPages);
      setGivenPage(data.data[0].page);
      setReqState(true);
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  };

  const getThumbnail = (link) => {
    const id = link.split('embed/');
    return `https://img.youtube.com/vi/${id[1]}/0.jpg`;
  };

  const handleConferenceTrigger = (conf) => {
    const confJSON = JSON.stringify(conf);
    localStorage.setItem('conf', confJSON);
    history.push(`/conferences/${conf._id}`);
  };

  return (
    <>
      <NavigationUser brandSize="122px" shadow={true}/>
      <div className={tabNav}>
        <div>
          <CustomButton onclick={() => setArePastConf(false)} disabled={!arePastConf} color={arePastConf ? 'btnOutline' : 'btnOrange'} content="Conferencias por venir" size="bg"/>
          <CustomButton onclick={() => setArePastConf(true)} disabled={arePastConf} color={arePastConf ? 'btnOrange' : 'btnOutline'} content="Conferencias pasadas" size="bg"/>
        </div>
      </div>
      <div className={container}>
        <div>
          {
            conferences &&
            conferences.map((conf, i) => 
              <div key={i}>
                <div className={confDate} onClick={() => handleConferenceTrigger(conf)}><b>{moment(conf.date).format('DD-MM-YYYY HH:mm')}</b></div>
                <div className={confItem} onClick={() => handleConferenceTrigger(conf)}>
                  <div style={{backgroundImage: `url(${getThumbnail(conf.youtubeLink)})`}}></div>
                  <div>
                    <div>
                      <div style={{backgroundImage: `url(${conf.image})`}}></div>
                    </div>
                    <div>
                      <h4>&thinsp;{conf.speakers}</h4>
                      <h5><b>{conf.name}</b></h5>
                      <div>
                        <p>{conf.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
          {
            loading &&
            <LoadingTable style={{alignSelf: 'center'}}/>
          }
          {
            noData &&
            <h3 style={{marginTop: '4rem'}}>¡Actualmente no hay conferencias programadas!</h3>
          }
        </div>
        <div>
          <CustomPaginate totalPages={totalPages} page={page} setPage={setPage}/>
        </div>
      </div>
    </>
  );
};

export default Conferences;
